import { connect } from "react-redux";
import { withRouter } from "react-router";
import { openPortfolioSidebar } from "actions/portfolio";
import { logoutUser } from "actions/user";
import { goBack, push } from "connected-react-router";
import { assetLeadSelector } from "selectors/assetLead";
import {
  hasBackButton,
  isAssetDetail,
  isAssetLeadDetail,
  isCalendar,
  isDashboard,
  isDealDetail,
  isSettings,
} from "selectors/location";

import Navbar from "./components/Navbar";

const mapStateToProps = (state) => ({
  currentAsset: state.asset,
  currentDeal: state.deal,
  currentAssetLead: assetLeadSelector(state),
  selectedPortfolioIDs: state.selectedPortfolioIDs,
  currentUser: state.currentUser,
  portfolios: state.portfolios,
  dashboardUrl: state.currentUser.company.dashboardUrl,
  hasBackButton: hasBackButton(state),
  isAssetDetail: isAssetDetail(state),
  isAssetLeadDetail: isAssetLeadDetail(state),
  isCalendar: isCalendar(state),
  isDashboard: isDashboard(state),
  isDealDetail: isDealDetail(state),
  isSettings: isSettings(state),
});

const mapDispatchToProps = (dispatch) => ({
  onBackClick: () => dispatch(goBack()),
  onCalendarClick: () => dispatch(push("/calendar")),
  onLogoutClick: () => dispatch(logoutUser()),
  onOpenSidebar: () => dispatch(openPortfolioSidebar()),
  onSettingsClick: () => dispatch(push("/settings/profile/details")),
  onToggleIntercom: () => window.Intercom && window.Intercom("show"),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navbar));
